import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-pending-delete-warning-dialog',
    templateUrl: './pending-delete-warning-dialog.component.html',
    styleUrls: ['./pending-delete-warning-dialog.component.scss']
})
export class PendingDeleteWarningDialogComponent {
    constructor(public dialogRef: MatDialogRef<PendingDeleteWarningDialogComponent>) { }
} 